/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataService } from '../http/dataService';
import { Observable } from 'rxjs';
import { EntityMetadata } from '../entity/entityMetadata';
import { Repository } from '../services/repository';
import { IGeoServer } from './models';
import { ColumnType, LanguagePage } from './types';
import { Result } from './helpers';

/**
 * this is used to identify and search
 * the different services created
 * and also for the menu
 */
export const PAGES = {
  VENDOR_GROUP_SALES: 'vendor',
  TEAM: 'team',
  TEAM_SALES_REP: 'team-sales-rep',
  APP_CONFIG: 'app-config',
  CONFIG_SETTING: 'config-setting',
  VALUE: 'values',
  TERRITORY_WALKLIST: 'territory-walklist',
  TERRITORY: 'territory',
  WALKLIST: 'walklist',
  DROP_WALKLIST: 'drop-walklist',
  SALES_WALKLIST: 'sales-walklist',
  ADDRESS_WALKLIST: 'adress-walklist',
  ACTIVITY_ADDRESS: 'activity-adress',
  INTEL: 'intel',
  DROP: 'drop-permission',
  KNOCK: 'knock-list',
  USER: 'user',
  ROLE: 'role',
  ROLE_USER: 'role-user',
  ADDRESS: 'address',
  FSA: 'fsa',
  TERRITORY_FSA: 'territory-fsa',
  PRIVILEGE: 'privilege',
  SALES: 'sales',
  WALKLISTLPDS: 'walklist-lpds',
  k2View: 'key2View',
  WALKLISTFSA: 'walklistfsa',
  ASSIGNMENT: 'assignment',
};
/**
 * this is used by the language service
 * to do translation by page
 */
export const LANGUAGE_PAGES = {
  VENDOR_GROUP_SALES: 'VendorGroupSalesPage',
  TEAM: 'TeamPage',
  TEAM_SALES_REP: 'TeamSalesRepPage',
  APP_CONFIG: 'App-ConfigPage',
  CONFIG_SETTING: 'ConfigSettingPage',
  VALUE: 'ValuePage',
  TERRITORY_WALKLIST: 'TerritoryWalklistPage',
  ACTIVITY_ADDRESS: 'ActivityAddressPage',
  WALKLIST_LPDS: 'WalklistLPDSPage',
  TERRITORY: 'TerritoryPage',
  WALKLIST: 'WalklistPage',
  ADDRESS_WALKLIST: 'AddressWalklistPage',
  INTEL: 'IntelPage',
  DROP: 'Drop-PermissionPage',
  KNOCK: 'KnockListPage',
  USER: 'UserPage',
  ROLE: 'RolePage',
  ROLE_USER: 'RoleUserPage',
  ADDRESS: 'AddressPage',
  FSA: 'FsaPage',
  PRIVILEGE: 'privilegePage',
  SALES: 'SalesPage',
  ASSIGNMENT: 'EventAssignmentPage',
  MYGEO: 'MyGeo',
  K2VIEW: 'k2View',
  PERMISSION: 'PermissionPage',
  ENTITLEMENT: 'EntitlementPage',
};

export interface PoolConfig {
  config: PageConfig;
  backend: Backend;
}

export interface EntityServiceConfig {
  url: string;
  client: DataService;
  headers?: HttpHeaders | { [header: string]: string | string[] };
}

export interface CrudService<T> {
  url: string;
  api: string;

  getAll(queryParams?): Observable<Result<T>>;

  getOne(queryString): Observable<T>;

  save(item: T): Observable<T>;
  update(item: T, id: string): Observable<T>;
  delete(id: string): Observable<T>;

  bulkAction(items: T[]): void;

  setUrl(url: string): void;

  setApi(api: string): void;
}

export interface ColumnConfig extends EntityColumnOptions {
  name: string;
}

export interface ColumnMetadata {
  [name: string]: ColumnConfig[];
}

export interface Services {
  [name: string]: PoolService;
}

export interface ServiceMetadata {
  [name: string]: ServiceOptions;
}

export interface Metadata {
  [name: string]: EntityMetadata;
}

export interface ServiceOptions {
  entity: Function;
  api: string;
  service: Function;
  headers?: HttpHeaders | { [header: string]: string | string[] };
}

export interface PoolService {
  service: Repository<any>;
}

export interface IEntityMetadata {
  entity: Function | string;
  language: LanguagePage;
  columns: ColumnConfig[];
}

export interface EntityColumnOptions {
  isPrimaryKey?: boolean;
  type: ColumnType;
  isEditable?: boolean;
  table?: ColumnOrderOption;
  form?: ColumnOrderOption;
}
export interface ColumnOrderOption {
  defaultPosition: number;
  hide?: boolean;
}

export const ACTIONS = {
  edit: 'edit',
  update: 'put',
  delete: 'delete',
  create: 'post',
};

export interface ConfigColumns<T> {
  dropdownFields?: string[];
  hiddenFormFields?: string[];
  hiddenTableFields?: string[];
  editableFields?: string[];
  keys: T;
}

export interface Backend {
  central: Endpoint;
  reproster: Endpoint;
  geoserver: Endpoint;
  k2view: Endpoint;
  ams: Endpoint;
  d2cGeo: Endpoint;
  dsa: Endpoint;
}

export interface Endpoint {
  limit?: number;
  desc?: boolean;
  endpoint: string | CentralApis;
}

export interface CentralApis {
  territory: string;
  appConfig: string;
  iam: string;
  activity: string;
}

export interface RepRosterResult<T> {
  totalSize: number;
  done: boolean;
  nextRecordsUrl?: string;
  records: T[];
}

export interface ResultGeoServerLinks {
  href: string;
  rel: string;
  title: string;
  type: string;
}

export interface ResultGeoServer {
  totalFeatures: number;
  type: string;
  features: IGeoServer[];
  numberMatched: number;
  numberReturned: number;
  links: ResultGeoServerLinks[];
}

export interface PageConfig {
  maxCol: number;
  http: HttpClient;
  queryItemsLimit?: number;
}
